import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'roster-classlink',
    components: {},
})

export default class RosterClasslink extends Vue {
    @Prop()
    private ssoDetails: any;

    private ssoFields: any = {
        districtRoster: {
            name: 'District Roster App Id',
            field: 'b-form-input',
            modelKey: 'districtRoster',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        districtName: {
            name: 'District  Name',
            field: 'b-form-input',
            modelKey: 'districtName',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        authenticationType: {
            name: 'Authentication Type',
            field: 'b-form-input',
            modelKey: 'authenticationType',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
    };

    private bearerToken: any = {
        token: {
            name: 'Bearer(token)',
            field: 'b-form-textarea',
            modelKey: 'token',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
    };
}
